import { useEffect } from 'react';
import { useAuthStore } from '../store/authStore';
import { useNotificationStore } from '../store/notificationStore';
import { connectDashboardSocket, disconnectDashboardSocket } from '../services/dashboardSocket';

export default function DashboardSocketBridge() {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);

  useEffect(() => {
    if (!user?.id || !token) {
      disconnectDashboardSocket();
      return;
    }

    connectDashboardSocket({
      userId: user.id,
      userType: 'fleet_owner',
      onNotification: (payload) => useNotificationStore.getState().addNotification(payload),
    });

    return () => disconnectDashboardSocket();
  }, [user?.id, token]);

  return null;
}
